<template>
  <div ref="createModal" class="modal fade" id="modal-shop" tabindex="-1">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ params.data.title }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <template v-if="isNotLoad()">
            <div class="col-12">
              <div class="card">
                <div class="card-header">
                  <ul class="nav nav-tabs card-header-tabs nav-fill" data-bs-toggle="tabs">
                    <li class="nav-item">
                      <a href="#tabs-common" class="nav-link active" data-bs-toggle="tab"><!-- Download SVG icon from http://tabler-icons.io/i/home -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon me-1"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M6.331 8h11.339a2 2 0 0 1 1.977 2.304l-1.255 8.152a3 3 0 0 1 -2.966 2.544h-6.852a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304z" /><path d="M9 11v-5a3 3 0 0 1 6 0v5" /></svg>
                        Общее
                      </a>
                    </li>
                    <li class="nav-item">
                      <a href="#tabs-description" class="nav-link" data-bs-toggle="tab"><!-- Download SVG icon from http://tabler-icons.io/i/user -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon me-1">
                          <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
                          <path d="M14 3v4a1 1 0 0 0 1 1h4" />
                          <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
                          <path d="M9 17h6" />
                          <path d="M9 13h6" />
                        </svg>
                        Описание
                      </a>
                    </li>
                    <li class="nav-item">
                      <a href="#tabs-contacts" class="nav-link" data-bs-toggle="tab"><!-- Download SVG icon from http://tabler-icons.io/i/activity -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon me-1"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z" /><path d="M3 7l9 6l9 -6" /></svg>
                        Контакты
                      </a>
                    </li>
                    <li class="nav-item">
                      <a href="#tabs-upload-image" class="nav-link" data-bs-toggle="tab"><!-- Download SVG icon from http://tabler-icons.io/i/activity -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon me-1"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2" /><path d="M7 9l5 -5l5 5" /><path d="M12 4l0 12" /></svg>
                        Загрузка картинки
                      </a>
                    </li>
                    <li class="nav-item">
                      <a href="#tabs-table" class="nav-link" data-bs-toggle="tab"><!-- Download SVG icon from http://tabler-icons.io/i/activity -->
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-table me-1"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14" /><path d="M3 10h18" /><path d="M10 3v18" /></svg>
                        Таблица
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="card-body">
                  <div class="tab-content">
                    <div class="tab-pane active show" id="tabs-common">
                      <div class="mb-3">
                        <div class="row">
                          <div class="col-lg-6">
                            <div class="mb-3">
                              <label class="form-label">Название</label>
                              <input type="text" v-model="fields.name" class="form-control" name="example-text-input" placeholder="Название магазина" />
                              <span :class="{'is-invalid': v$.name.$invalid && v$.name.$dirty}"></span>
                              <div class="invalid-feedback" v-for="error of v$.name.$errors" :key="error.$uid">
                                {{ error.$message }}
                              </div>
                            </div>
                            <div class="mb-3">
                              <Slug :payload="{
                                val: fields.slug,
                                shop_id: fields.id,
                                title: fields.name,
                              }" :validation="v$" @onChange="onChangeSlug" @onSync="onSyncSlug" />
                            </div>
                          </div>
                          <div class="col-lg-6">
                            <div class="mb-3">
                              <label class="form-label">Категория</label>
                              <select v-model="fields.category" class="form-select">
                                <option disabled value="">Выбрать категорию</option>
                                <option :value="category['id']" v-for="category of getCategories()" :key="category['id']">{{ category['title'] }}</option>
                              </select>
                              <span :class="{'is-invalid': v$.category.$invalid && v$.category.$dirty}"></span>
                              <div class="invalid-feedback" v-for="error of v$.category.$errors" :key="error.$uid">
                                {{ error.$message }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="mb-3">
                        <div class="row">
                          <div class="col-lg-6">
                            <div class="mb-3">
                              <label class="form-label">Краткое описание</label>
                              <textarea v-model="fields.shortDescription" class="form-control" name="example-textarea-input" rows="12" placeholder="Краткое описание..."> </textarea>
                              <span :class="{'is-invalid': v$.shortDescription.$invalid && v$.shortDescription.$dirty}"></span>
                              <div class="invalid-feedback" v-for="error of v$.shortDescription.$errors " :key="error.$uid">
                                {{ error.$message }}
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6">
                            <div class="form-label">
                              <div class="row">
                                <div class="col">Картинка</div>
                                <!--<div class="col-auto">
                                  <button type="button" class="btn btn-light btn-icon btn-icon-small" aria-label="Delete">
                                    <IconX />
                                  </button>
                                </div>-->
                              </div>
                            </div>
                            <div class="mb-2" v-if="getImageSrc()">
                              <img :src="getImageSrc(200)" alt="" class="img-fluid">
                            </div>
                            <div>
                              <input type="file" class="form-control" accept="image/*" @change="onImageChange">
                            </div>
                            <span :class="{'is-invalid': v$.image.$invalid && v$.image.$dirty}"></span>
                            <div class="invalid-feedback" v-for="error of v$.image.$errors" :key="error.$uid">
                              {{ error.$message }}
                            </div>

                            <div class="row mt-3">
                              <div class="mb-3">
                                <label class="form-label">Склонение</label>
                                <input type="text" v-model="fields.declension" class="form-control" name="example-text-input" placeholder="Склонение на сайте" />
                                <span :class="{'is-invalid': v$.declension.$invalid && v$.declension.$dirty}"></span>
                                <div class="invalid-feedback" v-for="error of v$.declension.$errors" :key="error.$uid">
                                  {{ error.$message }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="mb-3">
                        <div class="row">
                          <div class="col-lg-6">
                            <div class="mb-3">
                              <label class="form-label">Оригинальная ссылка (чистая)</label>
                              <input type="text" v-model="fields.linkOrigin" class="form-control" name="example-text-input" placeholder="Ссылка" />
                              <span :class="{'is-invalid': v$.linkOrigin.$invalid && v$.linkOrigin.$dirty}"></span>
                              <div class="invalid-feedback" v-for="error of v$.linkOrigin.$errors" :key="error.$uid">
                                {{ error.$message }}
                              </div>
                            </div>
                            <div class="mb-3" v-if="hasLinkPartner()">
                              <label class="form-label">Запарнеренная ссылка</label>
                              <span>{{ fields.linkPartner }}</span>
                            </div>
                            <div class="mb-3" v-if="canDelete()">
                              <div class="row">
                                <div class="col-lg-6">
                                  <div class="mb-3">
                                    <label class="form-label">Активность</label>
                                    <label class="form-check form-switch">
                                      <input class="form-check-input" type="checkbox" v-model="fields.active">
                                    </label>
                                    <span :class="{'is-invalid': v$.active.$invalid && v$.active.$dirty}"></span>
                                    <div class="invalid-feedback" v-for="error of v$.active.$errors" :key="error.$uid">
                                      {{ error.$message }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-6">
                            <div class="mb-3">
                              <label class="form-label">Alias для поиска</label>
                              <textarea v-model="fields.aliasSearch" class="form-control" name="example-text-input" placeholder="Alias для поиска" rows="3" />
                              <span :class="{'is-invalid': v$.aliasSearch.$invalid && v$.aliasSearch.$dirty}"></span>
                              <div class="invalid-feedback" v-for="error of v$.aliasSearch.$errors" :key="error.$uid">
                                {{ error.$message }}
                              </div>
                            </div>
                            <div class="mb-3">
                              <label class="form-label">Кастомная ссылка</label>
                              <small class="form-hint">
                                Заполнять, если есть реальная необходимость
                              </small>
                              <input type="text" v-model="fields.linkCustom" class="form-control" name="example-text-input" placeholder="Ссылка" />
                              <span :class="{'is-invalid': v$.linkCustom.$invalid && v$.linkCustom.$dirty}"></span>
                              <div class="invalid-feedback" v-for="error of v$.linkCustom.$errors" :key="error.$uid">
                                {{ error.$message }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="tab-pane" id="tabs-description">
                      <div class="mb-3">
                        <PageBuilder
                            :payload="{
                              val: fields.longDescription,
                            }"
                            @onUpdate="longDescriptionUpdate"
                        />
                      </div>
                    </div>
                    <div class="tab-pane" id="tabs-contacts">
                      <div class="mb-3">
                        <Contacts
                            :payload="{
                              val: fields.contactInfo,
                            }"
                            @onUpdate="contactInfoUpdate"
                        />
                      </div>
                    </div>
                    <div class="tab-pane" id="tabs-upload-image">
                      <div class="mb-3">
                        <UploadImage />
                      </div>
                    </div>
                    <div class="tab-pane" id="tabs-table">
                      <div class="mb-3">
                        <Table />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="d-flex justify-content-center">
              <div class="spinner-border"></div>
            </div>
          </template>
        </div>
        <template v-if="isNotLoad()">
          <div class="modal-footer">
            <button class="btn btn-secondary" data-bs-dismiss="modal">
              Отмена
            </button>

            <template v-if="canDelete()">
              <button class="btn btn-danger" @click="onDelete" :class="{'disabled': isDisabledDelBtn()}" v-if="isViewDelBtn()">
                <span class="spinner-border spinner-border-sm me-2" v-show="isProcessDel()"></span>
                Удалить
              </button>
            </template>

            <button class="btn btn-primary ms-auto" @click="send" :class="{'disabled': isPending()}">
              <span class="spinner-border spinner-border-sm me-2" v-show="isPending()"></span>
              {{ params.data.btn }}
            </button>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import "./css/style.css"
import {computed, reactive, ref, onMounted, defineComponent, toRaw} from 'vue'
import {useVuelidate} from "@vuelidate/core"
import {required, fileSize, url} from "@/plugins/vuelidator"
//import IconX from "@/modules/shops/icons/IconX"
import createParams from "./services/params/create"
import updateParams from "./services/params/update"
import Helper from "@/services/Helper"
import Api from "@/modules/shops/pages/shops/services/Api"
import ShopImage from "@/modules/shops/services/ShopImage"
import Notify from "@/services/Notify"
import PageBuilder from "./components/page_builder/Index"
import Contacts from "./components/contacts/Index"
import UploadImage from "./components/upload_image/Index"
import Slug from "./components/slug/Index"
import {requiredIf, helpers} from "@vuelidate/validators"
import Permission from "@/modules/users/services/Permission"
import Table from "./components/table/Index"

export default defineComponent({
  name: "CreateUpdate",
  components: {
    //IconX,
    PageBuilder,
    Contacts,
    UploadImage,
    Slug,
    Table,
  },
  setup(props, {emit}) {
    const createModal = ref(null);
    const fields = reactive(getFields())

    let load = ref(false)
    let pending = ref(false)
    let bootModal = null;
    let $externalResults = reactive({})
    let params = ref(getParams())
    let categories = ref([])
    let imageSrc = ref(null)
    let deleting = ref(false)

    const rules = computed(() => ({
      name: {
        required
      },
      shortDescription: {},
      longDescription: [],
      contactInfo: {},
      category: {
        required
      },
      image: {
        fileSize: fileSize(
            {
              maxFileSizeInB: 5242880,
              maxFileSizeInMB: 5,
            }
        )
      },
      linkCustom: {
        url,
      },
      linkOrigin: {
        url,
        required,
      },
      aliasSearch: {},
      active: {},
      slug: {
        required: helpers.withMessage(
            // todo не очень хорошо, рассинхрон с основным словарем-переводом
            "Это поле необходимо заполнить",
            requiredIf(() => !Helper.isEmpty(fields.id))
        )
      },
      declension: {
        required,
      },
    }))

    const v$ = useVuelidate(rules, fields, {$externalResults});

    function getParams() {
      return {
        data: {
          title: "",
          btn: "",
          page: "",
        }
      }
    }

    function resetParams() {
      params.value = getParams()
    }

    function isNotLoad() {
      return load.value === false
    }

    function markLoad() {
      return load.value = true
    }

    function markUnload() {
      return load.value = false
    }

    function isPending() {
      return pending.value === true
    }

    function markPending() {
      return pending.value = true
    }

    function markUnpending() {
      return pending.value = false
    }

    function getFields() {
      return {
        id: null,
        name: '',
        shortDescription: '',
        longDescription: [],
        contactInfo: {
          address: '',
          phone: '',
          url: '',
          common_info: '',
        },
        category: '',
        image: null,
        linkCustom: '',
        linkOrigin: '',
        linkPartner: '',
        aliasSearch: '',
        active: true,
        slug: '',
        declension: '',
      }
    }

    function validate(fn) {
      clearValidate()
      return v$.value.$validate().then((resp) => {
        if (resp === false) {
          Notify.error("Ошибка валидации")
          return false
        }
        fn()
      })
    }

    function clearValidate() {
      v$.value.$clearExternalResults()
      v$.value.$reset()
    }

    function showModal(event) {
      const button = event.relatedTarget
      const type = button.getAttribute('data-type')

      loadCategories()

      if (type === "create") {
        setParams(createParams)
        create(event)
      } else {
        setParams(updateParams)
        update(event)
      }
    }

    function setParams(val) {
      params.value = val
    }

    function create() {
      clearForm()
      markUnload()
    }

    function update(event) {
      const button = event.relatedTarget
      const id = button.getAttribute('data-id')

      Api.item({
        id: id,
      }).then((resp) => {
        let item = resp.data.item
        setFields(item)
        setImageSrc(item["image"])
      }).catch(() => {})
      .finally(() => {
        markUnload()
      })
    }

    function setFields(item) {
      fields.id = item["id"] || 0
      fields.name = item["title"] || ""
      fields.shortDescription = item["short_description"] || ""
      fields.longDescription = item["long_description"] || JSON.parse('[]')
      fields.contactInfo = item["contact_info"] || JSON.parse('{}')
      fields.category = item["category_id"] || 0
      fields.linkCustom = item["link_custom"] || ""
      fields.linkOrigin = item["link_origin"] || ""
      fields.linkPartner = item["link_partner"] || ""
      fields.aliasSearch = item["alias_search"] || ""
      fields.active = item["active"] === 1
      fields.slug = item?.slug || ""
      fields.declension = item?.declension || ""
    }

    function setImageSrc(val) {
      imageSrc.value = val
    }

    function getImageSrc(w) {
      if (!hasImageSrc()) {
        return null
      }

      return ShopImage.handle(imageSrc.value["host"], imageSrc.value["name"], w)
    }

    function hasImageSrc() {
      return imageSrc.value != null
    }

    function loadCategories() {
      Api.categories().then((resp) => {
        let items = resp.data.items
        let values = []

        Object.entries(items).forEach(([key, val]) => {
          values[key] = val
        })

        categories.value = values
      }).catch(() => {})
        .finally(() => {})
    }

    function preShowModal() {
      markLoad()
      resetParams()
      clearValidate()
      resetOther()
    }

    function resetOther() {
      setImageSrc(null)
    }

    onMounted(() => {
      bootModal = new bootstrap.Modal(createModal.value, {
        backdrop: 'static',
        keyboard: false
      });

      createModal.value.addEventListener('click', function (e) {
        if (e.target === createModal.value) {
          const shouldClose = confirm("Закрыть окно?");
          if (shouldClose) {
            bootModal.hide();
          }
        }
      });

      createModal.value.addEventListener('shown.bs.modal', showModal);
      createModal.value.addEventListener('show.bs.modal', preShowModal);
    })

    function getPayload(obj) {
      const formData = new FormData()

      Object.entries(obj).forEach(([key, val]) => {
        if (val instanceof File || val instanceof Blob) {
          formData.append(key, val)
          return
        }

        if (Array.isArray(val) || typeof val === 'object') {
          formData.append(key, JSON.stringify(val))
          return
        }

        if (typeof val === 'boolean') {
          formData.append(key, val ? 'true' : 'false')
          return
        }

        if (typeof val === 'number') {
          if (Number.isFinite(val)) {
            formData.append(key, val.toString())
          }
          return
        }

        formData.append(key, val)
      })

      return formData
    }

    function send() {
      validate(() => {
        markPending()

        let obj = {
          title: fields.name,
          short_description: fields.shortDescription,
          long_description: toRaw(fields.longDescription),
          contact_info: toRaw(fields.contactInfo),
          category_id: fields.category,
          link_custom: fields.linkCustom,
          link_origin: fields.linkOrigin,
          alias_search: fields.aliasSearch,
          active: fields.active,
          slug: fields.slug,
          declension: fields.declension,
        }

        if (fields.image) {
          obj = Helper.mergeObject(obj, {
            image: fields.image,
          })
        }

        if (fields.id && isPageUpdate()) {
          obj = Helper.mergeObject(obj, {
            id: fields.id,
          })
        }

        let payload = getPayload(obj)
        
        params.value.action({
          modal: bootModal,
          payload,
        }).then((resp) => {
          clearForm()
          clearValidate()
          Notify.success(resp)
          if (isPageUpdate()) {
            emit("onUpdate")
          } else {
            emit("onCreate")
          }
        }).catch((resp) => {
          Notify.error(resp)
        }).finally(() => {
          markUnpending()
        })
      })
    }

    function clearForm() {
      let items = getFields()
      for (let key of Object.keys(items)) {
        fields[key] = items[key]
      }
    }

    function onImageChange(e) {
      fields.image = e.target.files[0]
    }

    function getCategories() {
      return categories.value
    }

    function onDelete() {
      if (confirm("Вы действительно хотите удалить магазин?")) {
        startDeleting()
        Api.delete({id: fields.id}).then(() => {
        }).then(() => {
          Notify.success("Магазин удален")
          emit("onDelete")
          bootModal.hide();
        }).finally(() => {
          stopDeleting()
        })
      }
    }

    function isDisabledDelBtn() {
      return isProcessDel()
    }

    function isProcessDel() {
      return deleting.value === true
    }

    function startDeleting() {
      deleting.value = true
    }

    function stopDeleting() {
      deleting.value = false
    }

    function isPageUpdate() {
      return params.value.data.page === "update"
    }

    function isViewDelBtn() {
      return isPageUpdate()
    }

    function hasLinkPartner() {
      return !Helper.isEmpty(fields.linkPartner)
    }
    
    function longDescriptionUpdate(val) {
      fields.longDescription = val
    }

    function contactInfoUpdate(val) {
      fields.contactInfo = val
    }

    async function onSyncSlug(status) {
      if (status === true) {
        let resp = await Api.item({
          id: fields.id
        })

        let item = resp.data.item

        setFields(item)
        setImageSrc(item["image"])

        Notify.success("Синхронизировано")
      } else {
        Notify.error("Ошибка синхронизации")
      }
    }

    function onChangeSlug(val) {
      fields.slug = val
    }

    function canDelete() {
      return Permission.hasPermissions("admin_shop_delete")
    }

    return {
      isNotLoad,
      v$,
      fields,
      createModal,
      send,
      isPending,
      onImageChange,
      params,
      getCategories,
      getImageSrc,
      hasImageSrc,
      onDelete,
      isDisabledDelBtn,
      isProcessDel,
      isViewDelBtn,
      hasLinkPartner,
      longDescriptionUpdate,
      contactInfoUpdate,
      onSyncSlug,
      onChangeSlug,
      canDelete,
    }
  }
})
</script>
